import React from "react";
import Video from "../video";
import PomoTimer from "../pomo-timer";
import styled from "styled-components";

export default function GroupVideo(){
    return <Root>
        <Video />
        <PomoTimer />
    </Root>;
}

const Root = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr;
    padding: 1rem;
    column-gap: 1rem;
`;